import Color from 'color';
import styled from 'styled-components';

import { GREIGE } from '../../../theme/colors';
import { column, grid, row } from '../../../theme/grid';
import { MAX_WIDTH, SIZE, ZINDEX_CONTENT, mediaQuery, pixelate, unit } from '../../../theme/metrics';
import { typeBodyMd, typeHeadingLg, typeLabelMd } from '../../../theme/typography';

export const Container = styled.div`
	position: relative;
	z-index: ${ZINDEX_CONTENT + 2};
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	padding-top: ${unit(30)};
	padding-bottom: ${props => props.isWithImage ? `0` : `${unit(25)}`};
	text-align: center;
	background-color: ${props => props.theme.background};

	${mediaQuery[SIZE.medium]} {
		padding-top: ${unit(35)};
		padding-bottom: ${props => props.isWithImage ? `0` : `${unit(35)}`};
	}

	${mediaQuery[SIZE.xlarge]} {
		padding-top: ${unit(34.75)};
		padding-bottom: ${props => props.isWithImage ? `0` : `${unit(23)}`};
	}
`;

export const Wrapper = styled.div`
	${grid({ medium: true })}
	max-width: ${pixelate(MAX_WIDTH)};
	width: 100%;
	margin-left: auto;
	margin-right: auto;
`;

export const ContentWrapper = styled.div`
	${row({ medium: true })}
	position: relative;
	z-index: ${ZINDEX_CONTENT + 2};
`;

export const Content = styled.div`
	${column({ medium: { span: 12 } })};
	position: relative;
	z-index: ${ZINDEX_CONTENT + 2};
	display: flex;
	flex-direction: column;
	align-items: center;
	color: ${props => props.theme.primary};
`;

export const Label = styled.div`
	${typeLabelMd};
	flex: 1;
	width: 100%;

	color: ${GREIGE};
`;

export const Title = styled.h1`
	${typeHeadingLg};
	margin-top: ${unit(3.5)};
	margin-bottom: 0;
	

	${mediaQuery[SIZE.medium]} {
		margin-bottom: ${unit(3.5)};
	}
`;

export const Description = styled.p`
	${typeBodyMd};
	color: ${props => Color(props.theme.primary).alpha(0.9).string()};

	${mediaQuery[SIZE.large]} {
		max-width: 100%;
		white-space: pre-line;
	}
`;
